const state = {
  infoObj: {}
}

const mutations = {
  INFO_OBJ: (state, infoObj = {}) => {
    state.infoObj = infoObj
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
